export default {
  sm: `
  데이터는 개인을 넘어 지역과 사회, 국가의 경쟁력을 확보하는 중요한 자산입니다.
  우리의 소중한 자산인 데이터를 지키는 것, ‘데이터 주권’은 데이터 시대의 필수 과제입니다.데이터센터 각은 책임의식을 가지고 우리의 기술로 우리의 데이터를 지키겠습니다.
  `,
  md: `
  데이터는 개인을 넘어 지역과 사회, 국가의 경쟁력을 확보하는 중요한 자산입니다.
  우리의 소중한 자산인 데이터를 지키는 것, ‘데이터 주권’은 데이터 시대의
  필수 과제입니다. 데이터센터 각은 책임의식을 가지고 우리의 기술로
  우리의 데이터를 지키겠습니다.
  `,
  lg: `
  데이터는 개인을 넘어 지역과 사회, 국가의 경쟁력을 확보하는 중요한 자산입니다.
  우리의 소중한 자산인 데이터를 지키는 것, ‘데이터 주권’은 데이터 시대의 필수 과제입니다.
  데이터센터 각은 책임의식을 가지고 우리의 기술로 우리의 데이터를 지키겠습니다.
  `
};
